import React from 'react';
import { motion } from 'framer-motion';
import { admissionSlides } from '../mock';
import { ArrowRight } from 'lucide-react';

const AdmissionMarquee = () => {
  const items = [...admissionSlides, ...admissionSlides];
  return (
    <section className="bg-[#fbf7f2] py-20 overflow-hidden border-b border-[#eadfc9]">
      <div className="max-w-7xl mx-auto px-6 mb-10 flex items-end justify-between gap-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="tag-label">Admissions</div>
          <h3 className="font-serif-display text-3xl md:text-5xl font-black text-[#1c1a17] mt-3">
            Enrolment for the <span className="italic text-[#b8331f]">2026 / 2027</span> academic session
          </h3>
        </motion.div>
        <motion.a
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          href="#contact"
          className="hidden md:inline-flex items-center gap-2 font-sans-pro text-[12px] uppercase tracking-[0.28em] text-[#8f6417] hover:text-[#b8331f] transition-colors"
        >
          View Prospectus <ArrowRight size={14} />
        </motion.a>
      </div>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#fbf7f2] to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#fbf7f2] to-transparent z-10 pointer-events-none" />
        <div className="marquee-track flex gap-5 w-max">
          {items.map((src, i) => (
            <div key={i} className="w-56 md:w-72 aspect-[4/5] rounded-sm overflow-hidden shadow-lg bg-white shrink-0 border border-[#eadfc9]">
              <img src={src} alt={`slide-${i}`} className="w-full h-full object-cover" loading="lazy" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AdmissionMarquee;
